// filepath: c:\Users\greg\regulator\express\analysis-app\src\components\dashboard\charts\ChartAnnotations.jsx

import PropTypes from 'prop-types'

function ChartAnnotations({ 
  annotations = [], 
  onAnnotationClick = null,
  showLabels = true,
}) {
  // Generate annotation configuration for ApexCharts
  const generateAnnotations = () => {
    const config = {
      points: [],
      xaxis: [],
      yaxis: [],
      texts: [],
    };    annotations.forEach((annotation) => {
      const {
        type = 'point',
        x,
        y,
        label = '',
        color = '#007bff',
        strokeDashArray = 0,
        borderColor = color,
        fillColor = color,
        marker = {},
      } = annotation

      switch (type) {
        case 'point':
          if (x !== undefined && y !== undefined) {
            config.points.push({
              x,
              y,
              marker: {
                size: marker.size || 6,
                fillColor: marker.fillColor || fillColor,
                strokeColor: marker.strokeColor || borderColor,
                strokeWidth: marker.strokeWidth || 2,
                shape: marker.shape || 'circle',
              },
              label: showLabels ? {
                text: label,
                style: {
                  color: '#fff',
                  background: color,
                  fontSize: '12px',
                },
                offsetY: -10,
                offsetX: 0,
              } : undefined,
            })
          }
          break

        case 'xaxis':
          if (x !== undefined) {
            config.xaxis.push({
              x,
              strokeDashArray,
              borderColor,
              label: showLabels ? {
                text: label,
                style: {
                  color: '#fff',
                  background: color,
                  fontSize: '12px',
                },
                orientation: 'horizontal',
                position: 'top',
              } : undefined,
            })
          }
          break

        case 'yaxis':
          if (y !== undefined) {
            config.yaxis.push({
              y,
              strokeDashArray,
              borderColor,
              label: showLabels ? {
                text: label,
                style: {
                  color: '#fff',
                  background: color,
                  fontSize: '12px',
                },
              } : undefined,
            })
          }
          break

        case 'rectangle':
          if (x !== undefined && y !== undefined) {
            config.texts.push({
              x,
              y,
              text: label,
              textAnchor: 'start',
              style: {
                color,
                fontSize: '12px',
                fontWeight: 'bold',
                background: 'rgba(255, 255, 255, 0.8)',
                padding: '2px 4px',
                borderRadius: '2px',
              },
            })
          }
          break

        case 'text':
          if (x !== undefined && y !== undefined) {
            config.texts.push({
              x,
              y,
              text: label,
              textAnchor: 'middle',
              style: {
                color,
                fontSize: '12px',
                fontWeight: 'normal',
              },
            })
          }
          break

        default:
          console.warn(`Unknown annotation type: ${type}`)
      }
    })

    return config
  }

  // Handle annotation clicks
  const handleAnnotationClick = (event, _chartContext, config) => {
    if (onAnnotationClick && config.dataPointIndex !== undefined) {
      const annotation = annotations[config.dataPointIndex]
      onAnnotationClick(annotation, event)
    }
  }

  // Return the annotations configuration
  const annotationConfig = generateAnnotations()

  // Add click event if handler is provided
  if (onAnnotationClick) {
    annotationConfig.events = {
      click: handleAnnotationClick,
    }
  }

  return annotationConfig
}

// Helper function to create common annotation types
ChartAnnotations.createThresholdLine = (value, label = 'Threshold', color = '#ff6b6b') => ({
  type: 'yaxis',
  y: value,
  label,
  color,
  strokeDashArray: 5,
})

ChartAnnotations.createTimeMark = (timestamp, label = 'Event', color = '#4ecdc4') => ({
  type: 'xaxis',
  x: new Date(timestamp).getTime(),
  label,
  color,
  strokeDashArray: 3,
})

ChartAnnotations.createDataPoint = (x, y, label = 'Point', color = '#45b7d1') => ({
  type: 'point',
  x,
  y,
  label,
  color,
})

ChartAnnotations.createTextLabel = (x, y, text, color = '#333') => ({
  type: 'text',
  x,
  y,
  label: text,
  color,
})

ChartAnnotations.propTypes = {
  annotations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['point', 'xaxis', 'yaxis', 'rectangle', 'text']),
      x: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      y: PropTypes.number,
      label: PropTypes.string,
      color: PropTypes.string,
      strokeDashArray: PropTypes.number,
      borderColor: PropTypes.string,
      fillColor: PropTypes.string,
      marker: PropTypes.object,
    }),
  ),
  onAnnotationClick: PropTypes.func,
  showLabels: PropTypes.bool,
}

export default ChartAnnotations
